import type { AmendmentRequest } from "./use-amendments-store";

export const MAX_AMENDMENT_FILE_SIZE = 10 * 1024 * 1024;

export interface AmendmentValidationError {
  field: "reason" | "basis" | "responsible" | "legalChangeDate";
  message: string;
}

export const validateAmendmentRequest = (
  request: Pick<
    AmendmentRequest,
    | "reason"
    | "basis"
    | "responsible"
    | "requestSource"
    | "legalChangeDate"
  >,
): AmendmentValidationError[] => {
  const errors: AmendmentValidationError[] = [];

  if (!request.reason.trim()) {
    errors.push({
      field: "reason",
      message: "Укажите причину внесения изменений",
    });
  }
  if (!request.basis.trim()) {
    errors.push({
      field: "basis",
      message: "Укажите основание для внесения изменений",
    });
  }
  if (!request.responsible.trim()) {
    errors.push({
      field: "responsible",
      message:
        "Выберите представителя, ответственного за внесение изменений",
    });
  }
  if (request.requestSource === "SYSTEM" && !request.legalChangeDate) {
    errors.push({
      field: "legalChangeDate",
      message: "Укажите юридическую дату изменения",
    });
  }

  return errors;
};

export const validateAmendmentFile = (
  file: Pick<File, "name" | "size" | "type">,
) => {
  const isPdf =
    file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf");

  if (!isPdf) {
    return "Можно загрузить только файл в формате PDF";
  }
  if (file.size > MAX_AMENDMENT_FILE_SIZE) {
    return "Размер файла не должен превышать 10 МБ";
  }

  return null;
};
